import { ReducersTypes } from "constants/ReducersTypes";

const initialData = {
  loginInfo: {
    token: "",
    client_id: "",
    email_address: "",
  },
  invoiceSearchData: [],
};

const guestUserData = (state = initialData, action) => {
  const { type, payload } = action;
  switch (type) {
    case ReducersTypes.SET_GUEST_USER_DATA:
      return {
        ...state,
        ...payload,
      };
    case ReducersTypes.RESET_GUEST_USER_DATA:
      return initialData;
    default:
      return state;
  }
};

export default guestUserData;
